import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HelperService} from '../helpers';
import {ActivatedRoute, Router} from '@angular/router';
import {StorageService} from '../storage.service';
import {forkJoin, of} from 'rxjs';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  public contractors: any = [];
  public contractor: any = null;

  public units: any = [];
  public timetables: any = [];
  public premiums: any = [];

  public user: any;

  public loadingData = false;

  public faqUrl = environment.faqUrl;

  constructor(
    private http: HttpClient,
    private helper: HelperService,
    private router: Router,
    private route: ActivatedRoute,
    private storage: StorageService,
  ) {
  }

  ngOnInit() {
    this.user = this.storage.getItem('premium|auth');

    this.loadingData = true;
    this.http.get(this.helper.getApiUrl('/zdravstvene-ustanove')).subscribe((contractors) => {
      this.contractors = contractors;
      this.contractor = contractors[0];
      this.route.params.subscribe((params) => {
          if (!params.contractor) {
            this.router.navigate(['/ustanova', this.contractor.id]);
          } else {

            let premium$ = of([] as any);
            if (this.contractor.acf.contractor_premium) {
              premium$ = this.http.get(this.helper.getApiUrl('/premium?premium_mainContractor=' + params.contractor));
            }

            forkJoin(
              this.http.get(this.helper.getApiUrl('/enote?contractor_contractorUnit_relation=' + params.contractor)),
              this.http.get(this.helper.getApiUrl('/timetable?timetable_mainContractor=' + params.contractor)),
              premium$,
            ).subscribe((results: any[]) => {
              this.loadingData = false;
              this.units = results[0];
              this.timetables = results[1];
              this.premiums = results[2];
            });
          }
        }
      );
    });
  }

  logout() {
    this.storage.removeItem('premium|auth');
    this.router.navigate(['/login']);
  }
}
